import { ANIMALS } from 'constants';
import audioFormat from 'lib/audioFormat';
import loadAudio from 'lib/loadAudio';
import getAnimalObject from 'lib/getAnimalObject';


function getAudioPath(animalKey, level) {
  return `/static/sound/${animalKey}/${level}.${audioFormat}`;
}

function getAudioPaths() {
  const paths = [];
  ANIMALS.forEach((animal) => {
    for (let l = 0; l <= animal.maxLevel; l += 1) {
      paths.push(getAudioPath(animal.key, l));
    }
    paths.push(getAudioPath(animal.key, 'win'));
  });

  return paths;
}

class AudioPlayer {
  constructor() {
    if (window.AudioContext) {
      this.context = new window.AudioContext();
    } else if (window.webkitAudioContext) {
      this.context = new window.webkitAudioContext(); // eslint-disable-line
    } else {
      return;
    }
    this.loaded = false;
    this.loadedAmount = 0;

    loadAudio(getAudioPaths(), this.context, (amt) => {
      this.loadedAmount = amt;
    }).then((sounds) => {
      this.sounds = sounds;
      this.loadedAmount = 1;
      this.loaded = true;
    });
  }

  play(animalKey, level) {
    const animal = getAnimalObject(animalKey);
    const path = getAudioPath(animalKey, level);
    const sound = this.sounds.filter(s => s.path === path)[0];
    const source = this.context.createBufferSource();
    source.buffer = sound.buffer;
    source.connect(this.context.destination);
    source.start(0);

    return new Promise(resolve => setTimeout(resolve, animal.audioDuration));
  }
}

export default new AudioPlayer();



// WEBPACK FOOTER //
// ./src/lib/audioPlayer.js